import React from 'react';

import type { UIAnalyticsEvent } from '@atlaskit/analytics-next/src';
import Button from '@atlaskit/button/new';
import AddIcon from '@atlaskit/icon/core/add';

type CreateButtonProps = {
	children: React.ReactNode;
	onClick?: (e: React.MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
	testId?: string;
};

/**
 * __Create button__
 *
 * The create button for the top navigation.
 */
export const CreateButton = ({ children, onClick, testId }: CreateButtonProps) => (
	<Button appearance="primary" iconBefore={AddIcon} onClick={onClick} testId={testId}>
		{children}
	</Button>
);
